import { Appearance, DraftConfiguration, DraftState } from '@/types';
import { compareColors } from '@/utils/colors/compareColors';
import { invertColor } from '@/utils/colors/invertColor';
import { convertColors } from '@/model/printType/convertColors';

export const fixLowContrast = (
  configuration: DraftConfiguration,
  appearance: Appearance,
  draft?: DraftState
): void => {
  const newColors = configuration.printColors.map((printColor) => {
    const distance = compareColors(appearance.colors[0].value, printColor.fill);
    if (distance <= 20) {
      if (draft) {
        draft.warnings['lowContrast'] = 'warning.DoDconfiguration';
      }
      return { fill: invertColor(printColor.fill) };
    }
    return printColor;
  });
  configuration.printColors = convertColors(configuration.printType, newColors);
};
